import a from "./ghl-ui.es1550.js";
function r(t) {
  return a(this, t).get(t);
}
export {
  r as default
};
